import {devicemainUrls, devicemain} from './devicemain'

export const deviceUrls = [
  ...devicemainUrls
]

export const device = {
  devicemain
}



// WEBPACK FOOTER //
// ./src/api/gip/device/index.js